// Import React
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Material UI
import { styled } from '@mui/material/styles';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import CommentIcon from '@mui/icons-material/Comment';
import IconButton from '@mui/material/IconButton';

// Import our components
import Navbar from '../components/core/Navbar';
import ThreeColumnContent from '../components/core/ThreeColumnContent';

// Import our store
import useMySearchesStore, { addJob } from '../storage/MySearchesStore';
import { Box, Divider, Grid, Paper, Stack, Typography } from '@mui/material';
import JobStatusChip from '../components/results/JobStatusChip';
import Footer from '../components/core/Footer';
import { getJobStatus, JobRecord, JobStatus } from '../api/api';
import SearchJobListItem from '../components/search/SearchJobListItem';
import StandardView from '../components/core/StandardView';
import { usePolling } from '../hooks/usePollingRate';

// API

// Types
interface Props {

}

const PastSearchesPage = ({}: Props) => { 
  // We want to be able to access our global-store of the jobs we ran in the past.
  let mySearchesStore = useMySearchesStore();
  // We want to be able to redirect the user to another page when they click on a job.
  const navigate = useNavigate();

  // Styling overrides
  const MySearchesHeader = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.h3,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

  const MySearchesDescription = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.h5,
    textAlign: 'center',
    padding:'8px',
    color: theme.palette.text.secondary,
  }));

  // Setup a polling loop to check for updated results
  usePolling(() => {
    updatePastJobs();
  }, 30 * 1000);

  const updatePastJobs = () => {
    let promises = [];
    for (let job of mySearchesStore.pastJobs) {
      if (job && (job.status == JobStatus.QUEUED || job.status == JobStatus.RUNNING)) {
        // If the job is running or queued we need to query the state of it.
        promises.push(getJobStatus(job.uuid));
      }
    }
    Promise.all(promises);
  }

  // Render the page content.
  return (
    <StandardView>
      <MySearchesHeader style={{"color":"#004FA3", paddingBottom:'12px'}} sx={{fontSize: {"xs":32, "sm":48, "md":64}}}>Sequence Predictions</MySearchesHeader>
      <Divider></Divider>
      <MySearchesDescription>
        Select one of your past searches to see the results
      </MySearchesDescription>
      <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
        {/* Render the list of all of our past jobs */}
        <Divider></Divider>
        {/* Render past jobs in a list */}
        {Object.values(mySearchesStore.pastJobs).map((job : JobRecord, index) => (
          <Box key={index}>
            <ListItemButton
              onClick={() => {
                navigate("/search/" + job.uuid);
              }}
            >
              <SearchJobListItem job={job}></SearchJobListItem>
            </ListItemButton>
            <Divider></Divider>
          </Box>
        ))}
      </List>
    </StandardView>
  );
};

export default PastSearchesPage;